import React, { FC, memo } from 'react';
import { M23NavigationModule } from '~/lib/data-contract';
import { Container } from '../container/container.component';
import { CMSLink } from '~/shared/components/cms-link/cms-link.component';
import styles from './m23navigation.module.css';
import { clsx } from 'clsx';
import { isDarkColor } from '~/themes/cms-color-helpers';

const M23Navigation: FC<M23NavigationModule> = memo((props) => {
    const {
        backgroundColor,
        horizontalAlignment,
        links = [],
        spacingTop,
        spacingBottom,
        ...rest
    } = props;
    const isDarkShade = isDarkColor(backgroundColor);

    if (!links.length) {
        return null;
    }

    return (
        <Container
            hasGutter
            style={{ backgroundColor }}
            spacingTop={spacingTop ?? 'default'}
            spacingBottom={spacingBottom ?? 'default'}
            {...rest}
        >
            <nav className={clsx(styles.navigation, styles[horizontalAlignment ?? 'center'])}>
                {links?.map((link, index) => {
                    const text = link.text || link.title;

                    if (!text || !link.url) {
                        return null;
                    }

                    return (
                        <CMSLink
                            className={clsx(
                                styles.link,
                                isDarkShade ? styles.darkBackground : styles.lightBackground,
                                'hover-effect-underline-center'
                            )}
                            title={link.text}
                            key={index}
                            href={link.url}
                        >
                            {text}
                        </CMSLink>
                    );
                })}
            </nav>
        </Container>
    );
});

M23Navigation.displayName = 'M23Navigation';
export default M23Navigation;
